class WaitlistGuide extends HTMLElement {
  constructor() {
    super();
    this.closeButton = this.querySelector("[data-waitlist-close]");
    this.content = this.querySelector(".waitlist-guide__inner");
    this.currentTriggerBtn = null;

    this.addEventListener("click", (e) => {
      if (e.target.closest(".waitlist-guide__inner")) return;

      this.close();
    });

    document.addEventListener("click", this.handleDocumentClick);

    this.closeEsc = (e) => {
      if (e.key === "Escape") {
        this.close();
      }
    };

    document.addEventListener("keydown", this.closeEsc);
  }

  connectedCallback() {
    this.closeButton.addEventListener("click", (e) => {
      e.preventDefault();
      this.close();
    });

    document.addEventListener("waitlist-guide:open", (e) => {
      this.currentTriggerBtn = e.detail.triggerBtn;
      this.open();
      this.syncVariantFromProductForm();
    });
    document.addEventListener("waitlist-guide:close", () => this.close());
  }

  disconnectedCallback() {
    document.removeEventListener("keydown", this.closeEsc);
    document.removeEventListener("click", this.handleDocumentClick);
  }

  open() {
    if (this.hasAttribute("open")) return;
    this.style.display = "block";
    window.requestAnimationFrame(() => {
      this.setAttribute("open", "");
      window.openFullDimmer(this);
      window.lockScroll(this);
      this.returnFocusEl = document.activeElement;
      window.trapFocus(this, this.closeButton);
    });
  }

  close() {
    if (!this.hasAttribute("open")) return;
    this.removeAttribute("open");
    window.closeFullDimmer(this);

    const onEnd = () => {
      this.removeEventListener("transitionend", onEnd);
      if (this.hasAttribute("open")) return;
      this.style.display = null;
      window.removeTrapFocus(this.returnFocusEl);
      window.unlockScroll(this);
    };

    this.addEventListener("transitionend", onEnd);
  }

  updateTriggerButton(text) {
    if (this.currentTriggerBtn) {
      this.currentTriggerBtn.textContent = text;
      this.currentTriggerBtn.disabled = true;
    }
  }

  syncVariantFromProductForm() {
    const activeForm = document.querySelector("product-form-selectors");
    const selectedVariantId = activeForm?.querySelector('input[name="id"]')?.value;
    if (!selectedVariantId) return;

    this.querySelectorAll('.waitlist-form__size input[name="vid"]').forEach((radio) => {
      if (radio.value === selectedVariantId) {
        radio.checked = true;
        radio.setAttribute("checked", "checked");
        radio.dispatchEvent(new Event("change", { bubbles: true }));
      } else {
        radio.checked = false;
        radio.removeAttribute("checked");
      }
    });
  }
}

document.addEventListener("DOMContentLoaded", () => {
  if (!customElements.get("waitlist-guide"))
    customElements.define("waitlist-guide", WaitlistGuide);

  document.querySelectorAll(".waitlist-guide__trigger").forEach((btn) => {
    btn.addEventListener("click", (e) => {
      e.preventDefault();
      document.dispatchEvent(
        new CustomEvent("waitlist-guide:open", { detail: { triggerBtn: btn } })
      );
    });
  });

  // Waitlist form submit
  const submitBtn = document.getElementById("waitlist_submit");
  const emailInput = document.getElementById("waitlist_email");
  const consentBox = document.querySelector(".waitlist-guide__consent");
  const waitlistModal = document.querySelector("waitlist-guide");
  const messageBox = document.querySelector("#waitlist_message");
  console.log("window.theme.localeStrings.product.thank_you_message", window.theme.localeStrings.product);
  const klaviyoListId = window.theme?.klaviyo_list_id_waitlist;
  if (submitBtn) {
    submitBtn.addEventListener("click", async (e) => {
      e.preventDefault();

      let variantId = waitlistModal.querySelector('.waitlist-form__size input[name="vid"]:checked')?.value;
      const productId = waitlistModal.dataset.productId;
      const firstVariantId = waitlistModal.dataset.variantId;

      if (!variantId) {
        variantId = firstVariantId;
      }
      if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(emailInput.value))
        return alert("Please enter a valid email.");

      if (typeof BIS === "undefined")
        return alert("Waitlist service not ready.");

      const email = emailInput?.value.trim();
      
      if (klaviyoListId) {
        try { 
          const params = new URLSearchParams();
          params.append('g', klaviyoListId);
          params.append('email', email);
          params.append('a', 'VvnvnV');
          params.append('$fields', '$consent');
          params.append('signup_source', 'waitlist_drawer');
          if (productId) params.append('product_id', productId);
          if (variantId) params.append('variant_id', variantId);

          const response = await fetch('https://manage.kmail-lists.com/ajax/subscriptions/subscribe', {
            method: 'POST',
            headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
            body: params.toString(),
          });

          if (response.ok) {
            console.log('Added to Klaviyo drawer list');
          } else {
            const text = await response.text();
            console.warn('Klaviyo request failed:', text);
          }
        } catch (error) {
          console.error('Klaviyo subscription failed:', error);
        }
      }
      
      BIS.create(emailInput.value.trim(), variantId, productId)
        .then((data) => {
          if (data.status === "OK") {
            emailInput.value = "";
            if (consentBox) consentBox.checked = false;
            waitlistModal.querySelector(".waitlist-guide__content").style.display = "none";
            messageBox.textContent = window.theme.localeStrings.product.thank_you_message,
            messageBox.style.display = "block";
            waitlistModal.updateTriggerButton(window.theme.localeStrings.product.added_to_waitlist);
          } else {
            waitlistModal.querySelector(".waitlist-guide__content").style.display = "none";
            messageBox.textContent = window.theme.localeStrings.product.error_message;
            messageBox.style.display = "flex";
          }
        })
        .catch((err) => {
          messageBox.textContent = "Something went wrong. Please try again later.";
          console.error(err);
        });
    });
  }
});